// Restore Account errors
export const RESTORE_ACCOUNT_UNKNOWN_SAFE = 'unknownSafe';
export const RESTORE_ACCOUNT_INVALID_SEED_PHRASE = 'invalidSeedPhrase';
